export const STORAGE_KEY = {
  authInfo: 'customerAuthInfo',
};
